import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ForgotPasswordUiComponent } from '../../../shared/widgets/header/forgot-password-ui/forgot-password-ui.component';
import { SvgIconComponent } from 'angular-svg-icon';

const LOGIN_ROUTES = new Set([
  '/admin-auth',
  '/superadmin',
  '/tsp',
  '/taxareaoffice-login',
  '/governor',
  '/support-login',
  '/MDAmanager',
]);

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ForgotPasswordUiComponent, SvgIconComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  readonly loginUrl = this.getLoginUrl(
    this.route.snapshot.queryParamMap.get('returnUrl'),
  );

  private getLoginUrl(returnUrl: string | null): string {
    return returnUrl && LOGIN_ROUTES.has(returnUrl)
      ? returnUrl
      : '/admin-auth';
  }

  backToLogin(): void {
    void this.router.navigateByUrl(this.loginUrl);
  }
}
